import { RecordSummaryTrendPointDto } from './record-summary-trend-point.dto';

export class RecordSummaryTrendSeriesDto {
  key!: string;
  points!: RecordSummaryTrendPointDto[];
}
